import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'

import { HintComponent } from './HintComponent'

import styles from './HintLegend.module.scss'

interface IProps {
  text: string
  className?: string
  tipStyle?: string
}

export const HintLegend = (props: IProps) => {
  const translationMode = useSelector(selectTranslationMode)
  const isTranslationMode = translationMode === TranslationMode.Edit

  const hintText = props.text + '-hint'

  if (isTranslationMode) {
    return (
      <>
        <Translation text={props.text} actionsInside />
        <Translation text={hintText} actionsInside />
      </>
    )
  }

  return (
    <legend className={classNames(styles.legend, props.className)}>
      <div>
        <Translation text={props.text} actionsInside />
      </div>
      <HintComponent text={hintText} tipStyle={props.tipStyle} />
    </legend>
  )
}
